import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {MvsCrudService} from '../../../../core/shared/service/crud/mvs-crud.service';
import {FormatFunctionDefinitionDto} from '../../model/dto/api/format-function-definition.dto';
import {FormatPreviewRequestDto} from '../../model/dto/api/format-preview-request.dto';
import {FormatPreviewResponseDto} from '../../model/dto/api/format-preview-response.dto';

/**
 * Thin HTTP client for the backend `FormatFunctionRegistryController`.
 * Exposes definition discovery and live-preview execution used by the
 * FormatScriptEditor component.
 *
 * @ticket TM-1000001726
 */
@Injectable({providedIn: 'root'})
export class FormatFunctionRegistryService {

    /** Base path mirrors {@link FormatFunctionRegistryController} on the backend. */
    private readonly baseUrl = MvsCrudService.baseUrl + '/lg/formats';

    constructor(private http: HttpClient) {
    }

    /**
     * Lists ALL registered format functions.
     */
    listDefinitions(): Observable<FormatFunctionDefinitionDto[]> {
        return this.http.get<FormatFunctionDefinitionDto[]>(`${this.baseUrl}/definitions`);
    }

    /**
     * Retrieves a single function definition by upper-snake-case name.
     */
    getDefinition(name: string): Observable<FormatFunctionDefinitionDto> {
        return this.http.get<FormatFunctionDefinitionDto>(`${this.baseUrl}/definitions/${encodeURIComponent(name)}`);
    }

    /**
     * Lists distinct categories used to group functions in the Dropdown.
     */
    listCategories(): Observable<string[]> {
        return this.http.get<string[]>(`${this.baseUrl}/categories`);
    }

    /**
     * Executes a format-script using the supplied test variables. The backend
     * returns either {@code result} or {@code error}.
     */
    preview(request: FormatPreviewRequestDto): Observable<FormatPreviewResponseDto> {
        return this.http.post<FormatPreviewResponseDto>(`${this.baseUrl}/preview`, request);
    }
}
